import { useEffect } from "react";
import { useMsal, useMsalAuthentication } from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";
import { useSelector } from "react-redux";
import { loginRequest } from "~/packages/msalInstance";
import history from "~/packages/history";

const Login = () => {
  useMsalAuthentication(InteractionType.Redirect, loginRequest);

  const { accounts } = useMsal();
  const isAuthenticated = useSelector(
    (state: ReduxStore.State) => state.auth.isAuthenticated
  );

  useEffect(() => {
    if (accounts?.length > 0 && isAuthenticated) {
      history.push("/");
    }
  }, [accounts, isAuthenticated]);

  return null;
};

export default Login;